module.exports = __webpack_public_path__ + "media/images/payments/apple_subscription_invoice-5a07c35ac3d1c89cc6ebee0a138f103b.png";